"use strict";

exports.__esModule = true;
exports["default"] = exports.trackOptEvent = void 0;

var _optimizelySdk = require("@chegg/optimizely-sdk");

var _reactSdk = require("@optimizely/react-sdk");

var _isWindowDefined = _interopRequireDefault(require("./utils/isWindowDefined"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var optClient;
var trackingAdapterInstance;

var trackOptEvent = function trackOptEvent(event) {
  if (trackingAdapterInstance) trackingAdapterInstance(event);
};

exports.trackOptEvent = trackOptEvent;

var initializeOptimizly = function initializeOptimizly(config) {
  var _window, _window$location;

  if (!_isWindowDefined["default"] || !config) return null;

  if (config.shouldEnable) {
    if (!config.shouldEnable()) {
      return null;
    }
  }

  if (optClient) return optClient; // Setting some default values which can be overridden

  var _config$cookieDomain = config.cookieDomain,
      cookieDomain = _config$cookieDomain === void 0 ? '.chegg.com' : _config$cookieDomain,
      _config$queryStringOn = config.queryStringOnPageLoad,
      queryStringOnPageLoad = _config$queryStringOn === void 0 ? (_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.search : _config$queryStringOn,
      _config$logLevel = config.logLevel,
      logLevel = _config$logLevel === void 0 ? _reactSdk.enums.LOG_LEVEL.ERROR : _config$logLevel,
      rest = _objectWithoutPropertiesLoose(config, ["cookieDomain", "queryStringOnPageLoad", "logLevel"]);

  var _createCheggInstance = (0, _optimizelySdk.createCheggInstance)(_extends({
    queryStringOnPageLoad: queryStringOnPageLoad,
    cookieDomain: cookieDomain,
    logLevel: logLevel
  }, rest)),
      optimizely = _createCheggInstance.optimizely,
      trackingAdapter = _createCheggInstance.trackingAdapter;

  trackingAdapterInstance = trackingAdapter;
  optClient = optimizely;
  if (config.afterOptInit) config.afterOptInit(optimizely, trackingAdapter);
  return optClient;
};

var _default = initializeOptimizly;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/next-optimizely/dist/initializeOptimizely.js
// module id = 1697
// module chunks = 11